// 封装到window对象上的公共函数
// console封装
window.Log = function(input) {
    console.log(input);
}

import base from '../base.js'
// 封装到vue原型上的公共函数
export default {
    install(Vue, options) {
        // 删除登录信息
        Vue.prototype.commondelLocalAllData = function() {
            delete localStorage[base.localName]
        };
        //序列号
        //门店名称
        Vue.filter("filterStoreName", function(value) {
            if (!!value) {
                return value
            } else {
                return "无"
            }
        });
        //生成时间
        Vue.filter("filterBornTime", function(value) {
            if(!value){
	            return "未知日期"
	        }
	        var out = "0";
	        out = getLocalTime(value)
	        function getLocalTime(time) {
	            var date = new Date(parseInt(time) * 1000);
	            var hour = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
	            var minute = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
	            var second = date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
	            return date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate()+" "+hour+":"+minute+":"+second;
	        } 
	        return out;
        });
        //使用状态
        Vue.filter("usedStatus", function(value) {
            if (value == 1) {
                return "正常"
            } else if(value == 2){
                return "冻结"
            }else {
            	return "未投入使用"
            }
        });
        //激活状态
        Vue.filter("activationStatus", function(value) {
            if (value == 1) {
                return "激活"
            } else {
                return "未激活"
            }
        });
        // 删除空属性
        Vue.prototype.commonDelEmptyAttr = function(obj) {
            for(var x in obj){
                if(obj[x] === "" || obj[x] === null || obj[x] === undefined || obj[x] === 0){
                    delete obj[x]
                }
            };
            return obj;
        };
        // 时间对象转换成时间戳
        Vue.prototype.commonFucGetUnixTime = function(date) {
            if (!date) {
                return "";
            }
            var getDate = date;
            var year = getDate.getFullYear();
            var month = getDate.getMonth();
            var day = getDate.getDate();
            getDate = new Date(year, month, day);
            // 返回今日时间戳
            return parseInt(getDate.getTime() / 1000);
        };
        //租赁状态
        Vue.filter("leaseStatus", function(value) {
            if (Number(value) == 1) {
                return "否"
            } else {
                return "是"
            }
        });
        //判断
        Vue.filter("changUnkown", function(value) {
            if(value == "unkown" || value == null){
                return ""
            }else{
                return value
            }
        });
        //设备在线
        Vue.filter("isOnLine", function(value) {
            if(Number(value) == 1){
                return "在线"
            }else{
                return "不在线"
            }
        });
        // 秒转时分
        Vue.filter("turnHours", function(value) {
            if(!value){
                return "0分钟"
            };
            var h = Math.floor(value/3600%24);
            var m = Math.floor(value/60%60);
            if (h < 1) {
                return value = m + "分钟";
            } else {
                return value = h + "小时" + m + "分钟";
            }
        });
        // 判空
        Vue.filter("filterEmpty", function(value) {
            if(!value){
                return "0"
            }else{
                return value;
            }
            
        });
    }
}


// WEBPACK FOOTER //
// ./src/common_js/common.js